export default __webpack_public_path__ + "static/media/icon-rating.a9760f58.svg";